<ion-content class="ion-padding">
  <ion-grid class="my-grid">
    <ion-row class="parent-row">
      <form (ngSubmit)="handleSubmit()" [formGroup]="credentials">
        <div class="input-group">
          <!-- <ion-item lines="none">
      </ion-item> -->
          <ion-row>
            <ion-col
              size="12"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                *ngIf="type !=='register'"
                src="./assets/logoblack-normal.png"
                style="width: auto"
                [ngStyle]="{ 'max-height.px': type == 'register' ? '100' : '150' }"
              />
            </ion-col>
          </ion-row>
          <!-- TITLE -->
          <ion-item lines="none">
            <ion-label
              class="ion-text-center"
              style="text-transform: uppercase; font-weight: bold"
              color="primary"
            >
              <ng-container *ngIf="type==='login'">
                Iniciar Sesión
              </ng-container>
              <ng-container *ngIf="type==='register'">
                Registrar cuenta
              </ng-container>
              <ng-container *ngIf="type==='recover'">
                Recuperar contraseña
              </ng-container>
              <ng-container *ngIf="type==='change'">
                Cambiar contraseña
              </ng-container>
              <ng-container *ngIf="type==='verify'">
                Verificar Correo
              </ng-container>
            </ion-label>
          </ion-item>
          <!-- EMAIL -->
          <ng-container>
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input
                type="email"
                placeholder="Email"
                formControlName="email"
                appKeyboardFocus
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(email.dirty || email.touched) && email.errors"
              class="errors"
            >
              <span *ngIf="email.errors?.required">Email es requerido</span>
              <div *ngIf="email.errors?.email">
                Escriba un formato de email correcto
              </div>
              <div *ngIf="email.errors?.noWhiteSpace">
                No se permiten espacios en blanco
              </div>
            </div>
          </ng-container>

          <!-- NAME -->
          <ng-container *ngIf="type==='register'">
            <ion-item>
              <ion-label position="stacked">Nombre</ion-label>
              <ion-input
                type="text"
                placeholder="Nombre"
                formControlName="name"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(name.dirty || name.touched) && name.errors"
              class="errors"
            >
              <span *ngIf="name.errors?.required">Nombre es requerido</span>
            </div>
            <!-- BIRTHDATE -->
            <!-- <ion-item class="no-hover">
              <ion-label position="stacked">Fecha de nacimiento</ion-label>
              <ion-datetime
                displayFormat="DD MM YYYY"
                placeholder="Seleccionar fecha"
                formControlName="fecha_nacimiento"
                [pickerOptions]="customPickerOptions"
              ></ion-datetime>
            </ion-item>
            <div
              *ngIf="(fecha_nacimiento.dirty || fecha_nacimiento.touched) && fecha_nacimiento.errors"
              class="errors"
            >
              <span *ngIf="fecha_nacimiento.errors?.required"
                >fecha_nacimiento is required</span
              >
            </div> -->
            <!-- GENDER -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Género</ion-label>
              <ion-select placeholder="Género" formControlName="sexo">
                <ion-select-option
                  *ngFor="let sex of sexList; let i=index"
                  value="{{sex.id}}"
                  >{{sex.nombre}}</ion-select-option
                >
              </ion-select>
            </ion-item>
            <div
              *ngIf="(sexo.dirty || sexo.touched) && sexo.errors"
              class="errors"
            >
              <span *ngIf="sexo.errors?.required">Genero es requerido</span>
            </div>

            <!-- TELEFONO -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Teléfono</ion-label>
              <ion-select placeholder="+" formControlName="area" col-4>
                <ng-container *ngFor="let country of countryList; let i=index">
                  <ion-select-option
                    *ngIf="country.codigo_telefono"
                    [value]="{codigo:country.codigo_telefono,pais_id:country.id}"
                    >+{{country.codigo_telefono}} ({{country.nombre}})
                  </ion-select-option>
                </ng-container>
              </ion-select>
              <ion-input
                col-8
                slot="end"
                type="text"
                style="margin-top: 20px"
                formControlName="telefono"
                (keypress)="numericOnly($event)"
                inputmode="numeric"
                placeholder="Telefono"
              ></ion-input>
              <!-- <ion-grid fixed>
                <ion-row>
                  <ion-col size="7">
                    <ion-item lines="none">

                    </ion-item>
                  </ion-col>
                  <ion-col size="5">

                  </ion-col>
                </ion-row>
              </ion-grid> -->
            </ion-item>
            <div
              *ngIf="((telefono.dirty || telefono.touched) && telefono.errors) || ((area.dirty || area.touched) && area.errors)"
              class="errors"
            >
              <span *ngIf="telefono.errors?.pattern"
                >Solo se permiten caracteres numericos</span
              >
              <span *ngIf="area.errors?.required || telefono.errors?.required">
                Telefono es requerido
              </span>
            </div>

            <!-- PESO -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Peso (Kg)</ion-label>
              <ion-input
                placeholder="Peso"
                formControlName="peso"
                type="text"
                inputmode="numeric"
                (keypress)="numericOnly($event)"
                maxlength="3"
              >
              </ion-input>
            </ion-item>
            <div
              *ngIf="(peso.dirty || peso.touched) && peso.errors"
              class="errors"
            >
              <span *ngIf="peso.errors?.required">Peso es requerido</span>
            </div>
            <!-- ESTATURA -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Estatura (Cm)</ion-label>
              <ion-input
                placeholder="Estatura"
                formControlName="estatura"
                type="text"
                inputmode="numeric"
                (keypress)="numericOnly($event)"
                maxlength="3"
              >
              </ion-input>
            </ion-item>
            <div
              *ngIf="(estatura.dirty || estatura.touched) && estatura.errors"
              class="errors"
            >
              <span *ngIf="estatura.errors?.required"
                >Estatura es requerida</span
              >
            </div>
            <!-- OBJETIVO -->

            <ion-item class="no-hover">
              <ion-label position="stacked">Objetivo</ion-label>
              <ion-select placeholder="Objetivo" formControlName="objetivo">
                <ion-select-option
                  *ngFor="let obj of objectives; let i=index"
                  value="{{obj.id}}"
                  >{{obj.nombre}}</ion-select-option
                >
              </ion-select>
            </ion-item>
            <div
              *ngIf="(objetivo.dirty || objetivo.touched) && objetivo.errors"
              class="errors"
            >
              <span *ngIf="objetivo.errors?.required"
                >Objetivo es requerido</span
              >
            </div>
            <!-- PLAN -->

            <!-- <ion-item class="no-hover">
              <ion-label position="stacked">Plan</ion-label>
              <ion-select placeholder="Plan" formControlName="plan">
                <ion-select-option
                  *ngFor="let plan of plans; let i=index"
                  value="{{plan.id}}"
                  >{{plan.nombre}}</ion-select-option
                >
              </ion-select>
            </ion-item>
            <div
              *ngIf="(plan.dirty || plan.touched) && plan.errors"
              class="errors"
            >
              <span *ngIf="plan.errors?.required">Plan es requerido</span>
            </div> -->
          </ng-container>

          <!-- PASSWORD -->
          <ng-container *ngIf="type!=='recover' && type!=='verify'">
            <ion-item>
              <ion-label position="stacked">Contraseña</ion-label>
              <ion-input
                type="password"
                placeholder="Contraseña"
                formControlName="password"
                appKeyboardFocus
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(password.dirty || password.touched) && password.errors"
              class="errors"
            >
              <span *ngIf="password.errors?.required"
                >Contraseña es requerida</span
              >
              <span *ngIf="password.errors?.minlength"
                >Contraseña debe tener al menos 8 caracteres</span
              >
            </div>
          </ng-container>

          <!-- CONFIRMAR CONTRASENA -->
          <ng-container *ngIf="type==='change' || type ==='register'">
            <ion-item>
              <ion-label position="stacked">Confirmar Contraseña</ion-label>
              <ion-input
                type="password"
                placeholder="Confirmar Contraseña"
                formControlName="password_confirmation"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(password_confirmation.dirty || password_confirmation.touched) && password_confirmation.errors"
              class="errors"
            >
              <span *ngIf="password_confirmation.errors?.required"
                >Confirmar contraseña es requerida</span
              >
              <span *ngIf="password_confirmation.errors?.minlength"
                >Contraseña debe tener al menos 8 caracteres</span
              >
            </div>
            <div
              class="errors"
              *ngIf=" (password_confirmation.dirty || password_confirmation.touched) && (password_confirmation.value !== password.value)"
            >
              <span>Confirmación no coincide con la contraseña</span>
            </div>
          </ng-container>
          <ng-container *ngIf="type ==='change'">
            <ion-item>
              <ion-label position="stacked">Código verificación</ion-label>
              <ion-input
                type="text"
                placeholder="Codigo verificación"
                formControlName="token"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="(token.dirty || token.touched) && token.errors"
              class="errors"
            >
              <span *ngIf="token.errors?.required"
                >Código de verificación es requerido
              </span>
            </div>
          </ng-container>
          <!-- TERMINOS Y CONDICIONES -->
          <ion-grid *ngIf="type==='register'">
            <ion-row>
              <ion-col
                size="12"
                style="
                  display: flex;
                  justify-content: space-around;
                  align-items: center;
                "
              >
                <ion-checkbox
                  formControlName="terms"
                  style="margin-right: 15px"
                ></ion-checkbox>
                <ion-label
                  style="font-size: 12px; color: #4d4d4d; font-weight: 600"
                  >Acepto las
                  <span class="link" (click)="openAbout('terms')"
                    >condiciones</span
                  >
                  del servicio y
                  <span class="link" (click)="openAbout('privacy')"
                    >políticas</span
                  >
                  de privacidad</ion-label
                >
              </ion-col>
            </ion-row>
          </ion-grid>
          <!-- <ion-radio-group>
            <ion-row>
              <ion-col>
                <ion-item>
                  <ion-label>A</ion-label>
                  <ion-radio mode="md" item-left value="A"></ion-radio>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-label>B</ion-label>
                  <ion-radio mode="md" item-left value="B"></ion-radio>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-label>C</ion-label>
                  <ion-radio mode="md" item-left value="C"></ion-radio>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-radio-group> -->
        </div>

        <ion-button
          type="submit"
          expand="block"
          [disabled]="!credentials.valid"
        >
          <ng-container *ngIf="type==='login'"> Iniciar Sesión </ng-container>
          <ng-container *ngIf="type==='register'">
            Registrar cuenta
          </ng-container>
          <ng-container *ngIf="type==='recover'">
            Recuperar contraseña
          </ng-container>
          <ng-container *ngIf="type==='change'">
            Cambiar contraseña
          </ng-container>
          <ng-container *ngIf="type==='verify'"> Verificar </ng-container>
        </ion-button>

        <!-- SECONDARY TEXT -->
        <ion-button
          *ngIf="type==='login' && isGeneralVersion"
          type="button"
          expand="block"
          fill="clear"
          style="font-size: 10px"
          (click)="changeFormType('register')"
          >¿No esta registrado? Registrarse
        </ion-button>

        <ion-button
          *ngIf="type!=='login'"
          type="button"
          expand="block"
          fill="clear"
          style="font-size: 10px"
          (click)="changeFormType('login')"
          >¿Ya esta {{type==='verify'?'verificado':'registrado'}}? Iniciar
          sesión
        </ion-button>
        <ion-button
          *ngIf="type==='login'"
          type="button"
          expand="block"
          fill="clear"
          style="font-size: 10px"
          (click)="changeFormType('recover')"
          >¿Olvido su contraseña? Recuperar contraseña
        </ion-button>
        <!-- <ion-button
          *ngIf="type==='login'"
          type="button"
          expand="block"
          fill="clear"
          style="font-size: 10px"
          (click)="changeFormType('verify')"
          >¿No está verificado? Reenviar código
        </ion-button> -->
        <!-- <ion-button
          *ngIf="type==='login'"
          type="button"
          expand="block"
          fill="clear"
          style="font-size: 10px"
          (click)="changeFormType('change')"
          >Cambiar contraseña
        </ion-button> -->
      </form>
    </ion-row>
  </ion-grid>
</ion-content>
